import { createTheme } from './createTheme';
export var lightTheme = createTheme();
export var darkTheme = createTheme({
  palette: {
    mode: 'dark'
  }
});
export var theme = lightTheme;